import type { GiftCard, GiftCardGroup } from '../GiftCard.types'

export const isGiftCardGroup = (giftCard: GiftCard): giftCard is GiftCardGroup =>
  'groupId' in giftCard
